import React, { useState, Fragment, useRef } from "react";
import { NavLink } from "react-router-dom";
import CardArticle from "../../component/Card/CardArticle";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import Opportunity from "../../component/Other/Opportunity";

const Blog = (props) => {
    const blogs = [
        {
            img: "./../images/ghjghjh.png",
            tag: "Designer",
            title: "5 tips to be prepared for 2021 digital marketing trends",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
        {
            img: "./../images/rr (1).jfif",
            tag: "Development",
            title: "What to expect on your first technical interview?",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
        {
            img: "./../images/rr (5).jfif",
            tag: "Designer",
            title: "8 innovative design ideas to make your resume pop",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
        {
            img: "./../images/rr (4).jfif",
            tag: "Designer",
            title: "How to build a great team of marketing experts",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
        {
            img: "./../images/rr (3).jfif",
            tag: "Marketing",
            title: "The 4 Javascript frameworks with more active job openings",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
        {
            img: "./../images/rr (2).jfif",
            tag: "Development",
            title: "How to start your career as a UI/UX designer",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi gravida.",
            date: "Juni 27, 2022"
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">

                <Navbar type="blue" />


                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 mb-4 mb-lg-0">
                                <div className="wrapper__card-about bg__blue">
                                    <img src="./../images/News.png" className="mb-4" alt="" />

                                    <h4 className="medium font__size--32 text__32-1024 color__white mb-3">Resource & <br />Learning Center</h4>
                                    <p className="normal font__size--24 text__24-1024 color__white lh__4 mb-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Molestie id tincidunt malesuada pharetra arcu turpis cursus mattis fringilla. </p>

                                    <img src="./../images/fgfg (1).png" alt="" />

                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="wrapper__photo-grid blog d-flex">
                                    <div className="position-relative item first">
                                        <img src="./../images/ar (3).png" className="img-1" alt="" />
                                        <div className="bg"></div>
                                        <div className="tag medium font__size--16 text__16-1024 color__white">For Designer</div>
                                    </div>
                                    <div className="item wrap-1">
                                        <div className="position-relative wrap-1">
                                            <img src="./../images/ar (2).png" alt="" />
                                            <div className="bg"></div>
                                            <div className="tag medium font__size--16 text__16-1024 color__white">For Developer</div>
                                        </div>
                                        <div className="position-relative wrap-1">
                                            <img src="./../images/ar (1).png" alt="" />
                                            <div className="bg"></div>
                                            <div className="tag medium font__size--16 text__16-1024 color__white">For Marketers</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <h4 className="medium font__size--32 text__32-1024 mb-5">Latest Articles</h4>

                        <div className="row mb-4">
                            {
                                blogs.map((obj) => {
                                    return <div className="col-md-6 col-lg-4 mb-4">
                                        <CardArticle data={obj} />
                                    </div>
                                })
                            }
                        </div>

                        <div className="d-flex align-items-center justify-content-between">
                            <div className="wrapper__pagination d-flex align-items-center">
                                <svg className='pointer left' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.0001 29.3333C23.3639 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63616 23.3639 2.66663 16.0001 2.66663C8.63628 2.66663 2.66675 8.63616 2.66675 16C2.66675 23.3638 8.63628 29.3333 16.0001 29.3333Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.6799 20.7067L12.9866 16L17.6799 11.2933" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div className="mx-2 list">
                                    <div className="dot active"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                                <svg className='pointer right' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.0001 29.3333C23.3639 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63616 23.3639 2.66663 16.0001 2.66663C8.63628 2.66663 2.66675 8.63616 2.66675 16C2.66675 23.3638 8.63628 29.3333 16.0001 29.3333Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14.3201 20.7067L19.0134 16L14.3201 11.2933" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <h5 className="mb-0 medium font__size--18 text__18-1024">1/4</h5>
                        </div>

                    </div>
                </section>

                <Opportunity />

                <Footer />

            </div >
        </Fragment >
    );
};

export default Blog;
